/*eslint backbone/no-constructor:0 */
define('glu/collection',['require','backbone','./util','./http'],function(require) {
    'use strict';

    var Backbone = require('backbone'),
        util = require('./util'),
        http = require('./http');

    return Backbone.Collection.extend({
        constructor: function() {
            this.initialEvents();
            Backbone.Collection.prototype.constructor.apply(this, arguments);
        },

        requestingAttributes: false,

        initialEvents: function() {
            var self = this;

            this.listenTo(this, 'request', function() {
                self.requestingAttributes = true;
            });

            this.listenTo(this, 'sync', function() {
                self.requestingAttributes = false;
            });
        },

        sync: function(method, model, options) {
            options = options || {};

            util.defaults(options, {
                statusCode: http.statusCodeHandlers
            });

            return Backbone.Collection.prototype.sync.apply(this, arguments);
        },

        isLoading: function() {
            return this.requestingAttributes;
        }
    });
});

